module.exports = __webpack_public_path__ + "img/ufo_1075.d6638ada.svg";